module.exports = __webpack_public_path__ + "media/images/icons/flags/GY-995af9a6180683b1ae07339df8456586.svg";